import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { routes } from 'Routes'
import useFetch from 'hooks/useFetch'
import constants from 'constants/index'
import * as service from 'service'

/**
 * QuestionnairesReply - Componente de redirecionamento para o fluxo correto
 * Redireciona baseado no tipo do questionário:
 * - Suppliers (interaction='suppliers'): questionnaires/suppliers/:id/reply
 * - DpoNet (legado): questionnaires/dponet/:id/reply
 */
const QuestionnairesReply = ({ match }) => {
  const history = useHistory()
  const { questionnaireId } = match.params

  const { response } = useFetch(
    service.dponet.questionnaires.get,
    {
      questionnaireId,
    },
    [],
    !!questionnaireId,
  )

  const questionnaire = response?.data?.questionnaire || {}

  useEffect(() => {
    if (questionnaire?.id) {
      const isSupplierQuestionnaire =
        questionnaire.interaction ===
        constants.quizTemplates.INTERACTION_ENUMS.thridPartyDiagnostic
      const routePath = isSupplierQuestionnaire
        ? routes.supplierQuestionnaire.reply
        : routes.dponetQuestionnaire.reply

      history.replace(
        reverse(routePath, {
          questionnaireId,
        }),
      )
    }
  }, [questionnaire?.id, history, questionnaireId])

  return null
}

export default QuestionnairesReply
